import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './Reducers';
import { Map } from 'immutable';
import * as serviceWorker from './serviceWorker';
import { fromEventPattern } from 'rxjs';
import moment from 'moment';
import 'moment/locale/nl';


import ConnectionProvider from '@zorgconnect/shared-portal/Context/Connection';
import Authentication from '@zorgconnect/shared-portal/Modules/Authentication';

export const appVersion = "2.1.0";

moment.locale('nl', { dow: 1 });

let composeMiddleware = undefined;

if(window.__REDUX_DEVTOOLS_EXTENSION__) {
    composeMiddleware = compose(
        applyMiddleware(thunk),
        window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
    );
} else {
    composeMiddleware = applyMiddleware(thunk);
}


const store = createStore(
    rootReducer, 
    Map(),
    composeMiddleware
);

ReactDOM.render(
    <ConnectionProvider>
        <Authentication portalLabel="client" version={appVersion}>
            <Provider store={store}>
                <App />
            </Provider>
        </Authentication>
    </ConnectionProvider>, 
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
